export default "__VITE_ASSET__DFYF$1Bc__"